import { render, staticRenderFns } from "./ImportarModalNuevo.vue?vue&type=template&id=07c894ce&scoped=true&"
import script from "./ImportarModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ImportarModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ImportarModalNuevo.vue?vue&type=style&index=0&id=07c894ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c894ce",
  null
  
)

export default component.exports